module.exports = __webpack_public_path__ + "static/media/2.8b4cf44b.png";